export const cursorStyles = ["pointer", "hovered"]
